interface JoinTeamFormData {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    message: string;
    cv?: string | null;
}

interface ValidationMessages {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    message: string;
    cv: string;
}

export const validateJoinTeamForm = (
    formData: JoinTeamFormData,
    messages: ValidationMessages
): { [key: string]: string } => {
    const errors: { [key: string]: string } = {};

    const nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
    const phoneRegex = /^[0-9]{8,15}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!nameRegex.test(formData.firstName)) {
        errors.firstName = messages.firstName;
    }

    if (!nameRegex.test(formData.lastName)) {
        errors.lastName = messages.lastName;
    }

    if (!phoneRegex.test(formData.phone)) {
        errors.phone = messages.phone;
    }

    if (!emailRegex.test(formData.email)) {
        errors.email = messages.email;
    }

    if (!formData.message || formData.message.length < 10) {
        errors.message = messages.message;
    }

    if (!formData.cv) {
        errors.cv = messages.cv;
    }

    return errors;
};

export const validateContactForm = (
    data: { name: string; email: string; subject: string; message: string },
    errorsLang: any
) => {
    const errors: any = {};

    if (!/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/.test(data.name.trim())) {
        errors.name = errorsLang.name;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email.trim())) {
        errors.email = errorsLang.email;
    }

    if (data.subject.trim().length < 3) {
        errors.subject = errorsLang.subject;
    }

    if (data.message.trim().length < 10) {
        errors.message = errorsLang.message;
    }

    return errors;
};
